import detectPlatform from './detectplatform';
import convertVimeoToEmbed from './Vimeo';
import { createYouTubeEmbedUrl } from './Youtube';

export default function createVideoEmbedLink(videoLink: string) {
  const platform = detectPlatform(videoLink);
  if (platform === 'youtube') {
    return createYouTubeEmbedUrl(videoLink);
  }
  if (platform === 'vimeo') {
    return convertVimeoToEmbed(videoLink);
  }
  return videoLink; // Return the original link if no platform is detected
}
